import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { persistGotoForLogin } from 'app/_utils/helpers';

import { AuthenticationService } from '../_services';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authenticationService.isSessionValid()) {
      if (route.data && route.data['roles'] &&
        !this.authenticationService.is_in(route.data['roles'])) {
        this.router.navigate(['']);
        return false;
      }
      return true;
    }

    if (this.authenticationService.id()) {
      this.authenticationService.purgeLocalSession();
    }

    this.router.navigate(['login'], { queryParams: persistGotoForLogin(state.url) });
    return false;
  }
}
